import {TranslateService} from "@ngx-translate/core";
import {FieldConfig as FaultFieldConfig} from "@docma-mm-core/field-config/field-config";
import {HttpErrorResponse} from '@angular/common/http';

export function isIdsEquals(obj1: any, obj2: any) {
  const id1 = obj1 ? obj1.Id : null;
  const id2 = obj2 ? obj2.Id : null;

  return id1 === id2;
}

export function IsBoolsEqual(b1: boolean, b2: boolean) {
  return (!!b1) === (!!b2);
}

export function IsNumbersEqual(n1: number, n2: number) {
  if (!n1 && !n2) {
    return true;
  }
  return n1 === n2;
}



export function isDateEqual(d1: Date, d2: Date): boolean {
  if (!d1 && !d2) {
    return true;
  }
  if (d1 && d2 && new Date(d1).getTime() === new Date(d2).getTime()) {
    return true;
  }
  return false;
}

export function isStringsEqual(s1: string, s2: string): boolean {
  if ((s1 && !s2) || (!s1 && s2) || (s1 && s2 && s1 !== s2)) {
    return false;
  }
  return true;
}

export function getDuplicateName(duplicateName: string, names: string[], translateService: TranslateService): string {
  const namesDict: {[ixd: number]: string} = [];
  const escapeChars = /[\!\#\$\%\^\&\*\)\(\+\=\.\<\>\{\}\[\]\:\;\'\"\|\~\`\_\-]/g;

  const escapedDuplicateName = duplicateName.replace(escapeChars, '\\$&');

  for (const name of names) {
    const matchFirst = name.match(`${escapedDuplicateName}${translateService.instant('MM.general.copy.matchFirst')}`);
    const matchNext = name.match(`${escapedDuplicateName}${translateService.instant('MM.general.copy.matchNext')}`);

    if (matchFirst) {
      namesDict[0] = name;
    }
    else if (matchNext) {
      const subMatch = name.slice(matchNext.index, name.length).match(translateService.instant('MM.general.copy.matchNumber'));
      const i = +name.slice(matchNext.index + subMatch.index + 1, name.length - 1);
      namesDict[i] = name;
    }
    else if (duplicateName == name) {
      namesDict[-1] = name;
    }
  }

  let nameSuffix: string;

  if (Object.keys(namesDict).length === 0) {
    nameSuffix = "";
  }
  else if (Object.keys(namesDict).length === 1) {
    nameSuffix = translateService.instant('MM.general.copy.suffix')
  }
  else {
    nameSuffix = `${translateService.instant('MM.general.copy.suffix')} (${Math.max(...Object.keys(namesDict).map(x => +x)) + 1})`
  }
  return nameSuffix;
}

export function clearDictionary(dictionary: any) {
  for (let key in dictionary) {
    delete dictionary[key];
  }
}

export function getError(error: any) {
  let jsonError: any;

  // const getStringError = () => (error.toString() === '[object Object]' ? JSON.stringify(error) : error.toString());
  const getHttpError = () => `${(error as HttpErrorResponse).statusText} (${(error as HttpErrorResponse).status})`;


  if (error instanceof HttpErrorResponse) {
    try {
      if (error.error) {
        if (error.error instanceof Object) {
          if ((error.error?.InternalErrors?.length ?? 0) > 0) {
            return error.error;
          }
          else if (error.error.Code && error.error.Message) {
            return error.error.Message;
          }
          else {
            return getHttpError();
          }
        }
        else {
          jsonError = JSON.parse(error.error);
          if ((jsonError?.InternalErrors?.length ?? 0) > 0){
            return jsonError;
          }
        }
      }
      else if (error.message) {
        return error.message;
      }
    }
    catch {
      return (error?.error ? error.error : getHttpError());
    }
  }
  else if (error instanceof Error) {
    return error.message;
  }
  else {
    try {
      if (error instanceof Object && (error?.InternalErrors?.length ?? 0) > 0) {
        return error;
      }
      else {
        jsonError = error ? JSON.parse(error) : null;
        if ((jsonError?.InternalErrors ?? 0) > 0) {
          return jsonError;
        }
      }
    }
    catch {
      return error;
    }
  }

  return error;
}


export function getErrorMessage(error: any) {
  const errorObj = getError(error);
  return ((errorObj?.InternalErrors?.length ?? 0) > 0 && errorObj?.InternalErrors[0]?.Message ? errorObj.InternalErrors[0].Message : error);
}
